import { ActionTypesUi } from "../constants/action-types";
import axios, { Axios } from "axios";

const apiBaseUrl = process.env.REACT_APP_STRAPI_URL;
const access_token = process.env.REACT_APP_GET_PLAYER_TOKEN;
const ftv_access_token = process.env.REACT_APP_GET_FTV_PLAYER_TOKEN
console.log(process.env);
// console.log(access_token);
const setChatConfig = (config) => ({
    type: ActionTypesUi.SET_CHAT_CONFIG,
    payload: {
        config
    }
})

const uiPullError = (err) => {
    return {
        type: ActionTypesUi.UI_PULL_ERROR,
        payload: {
            error: err
        }
    }
}

export const pullConfig = (params, pageType) => {
    return async (dispatch, getState) => {
        try {
            let response = null;

            if (pageType === "call") {
                response = await axios.get(
                    `${apiBaseUrl}/web-rtc-configs?locale=${params['lang']}&populate=deep,3&filters[Template][Brand][$eq]=${params['brand']}`
                );
            } else {
                response = await axios.get(
                    `${apiBaseUrl}/chat-pages?locale=${params['lang']}&populate=deep,3&filters[Template][Brand][$eq]=${params['brand']}`
                );
            }

            const data = response.data.data;

            if (!data || data.length === 0) {
                // No data found, handle gracefully
                throw new Error('No configuration found for the specified parameters.');
            }

            // Dispatch valid data to the state
            dispatch(setChatConfig(data[0]));
            return data[0]; // Return the data for further validation
        } catch (error) {
            dispatch(uiPullError(error));
            return null; // Return null for failure cases
        }
    };
};


// Action to set player data
const setPlayerData = (data) => ({
    type: ActionTypesUi.SET_PLAYER_DATA,
    payload: {
        player: data
    }
});

// Action to handle player fetch errors
const playerPullError = (err) => {
    return {
        type: ActionTypesUi.PLAYER_PULL_ERROR,
        payload: {
            error: err
        }
    };
};

// Thunk action to fetch player data
export const pullPlayerData = (playerId, brand) => {
    // const access_token = 'a7ab5e8ebca2dd0564627c5c0295b44ba165f8ea0c7f6c7dc2346e4ecd381dea7fa804c94885cfd4df94080e620e7d4d4943e147a6e2afaef28b2b81c80d541b2dc588d0c6d5d4265abc5b22351df5569461cda81b0827dd0d0d55e5fb0152a34ae64ba5a0483a7300f37edcee4c4f9daf6fe2c35aaec2c03bcfa22bdabe8e53';

    return async(dispatch) => {
        try {
            if (brand.toLowerCase()==='ftv') {
                let { data } = await axios.get(`${apiBaseUrl}/ftv/players/${playerId}`, {
                    headers: {
                      'Authorization': `bearer ${ftv_access_token}`
                    }
                  });
                dispatch(setPlayerData(data)); // Dispatch the player data
            } else {

                let { data } = await axios.get(`${apiBaseUrl}/players/${playerId}`, {
                    headers: {
                      'Authorization': `bearer ${access_token}`
                    }
                  });
                dispatch(setPlayerData(data)); // Dispatch the player data
            }
        } catch (e) {
            dispatch(playerPullError(e)); // Dispatch error if any
        }
    };
};
